function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSublineAi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.101,
    height: 10.898,
    viewBox: "0 0 11.101 10.898",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1280"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 12",
    d: "M4.661 16.064h-.348a.584.584 0 0 1-.578-.471l-.229-.771a.359.359 0 0 1 .3-.428.368.368 0 0 1 .437.29l.207.642h.415a.387.387 0 0 1 .326.181c.274.448 1.31 1.885 1.31 1.885s1.037-1.43 1.311-1.885a.387.387 0 0 1 .326-.181h.414l.208-.642a.373.373 0 0 1 .437-.29.358.358 0 0 1 .3.428l-.229.771a.583.583 0 0 1-.578.471h-.356c-.422.564-1.111 2.066-1.837 2.066s-1.414-1.494-1.836-2.066z",
    transform: "translate(-.946 -7.232)",
    style: {
      fill: "#a7a7a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 13",
    d: "M1.546 9.79A1.272 1.272 0 0 1 .36 8.45a1.3 1.3 0 0 1 .963-1.312 1.346 1.346 0 0 1-.015-.2v-.03a.3.3 0 0 1 0-.033 1.2 1.2 0 0 1 1.121-1.2.919.919 0 0 1 .192.021A1.179 1.179 0 0 1 3.736 4.61a.941.941 0 0 1 .211.025 1.435 1.435 0 0 1 1.159-.623 1.4 1.4 0 0 1 1.041.488 1.626 1.626 0 0 1 1.135-.48 1.694 1.694 0 0 1 1.431.838A1.162 1.162 0 0 1 9.16 4.8a1.291 1.291 0 0 1 .925.515 1.637 1.637 0 0 1 .331 1.1 1.552 1.552 0 0 1-.024.2 1.741 1.741 0 0 1 .769 1.481 1.609 1.609 0 0 1-1.5 1.7zM.73 8.45a.876.876 0 0 0 .816.923h8.115a1.214 1.214 0 0 0 1.131-1.279 1.292 1.292 0 0 0-.69-1.178.216.216 0 0 1-.1-.256 1.252 1.252 0 0 0 .05-.27 1.188 1.188 0 0 0-.24-.8.936.936 0 0 0-.672-.373.853.853 0 0 0-.4.073 1.141 1.141 0 0 0-.642 1.054.186.186 0 1 1-.369 0 1.614 1.614 0 0 1 .644-1.312 1.323 1.323 0 0 0-1.085-.6 1.292 1.292 0 0 0-.93.414 1.844 1.844 0 0 1 .206.849 1.6 1.6 0 0 1-1.497 1.691.21.21 0 0 1 0-.417A1.2 1.2 0 0 0 6.189 5.7a1.2 1.2 0 0 0-1.122-1.269 1.1 1.1 0 0 0-.891.559.173.173 0 0 1-.209.081.665.665 0 0 0-.228-.044.81.81 0 0 0-.755.853c0 .026 0 .04.006.055a.222.222 0 0 1-.066.173.171.171 0 0 1-.164.041h-.021a.164.164 0 0 1-.064-.011.684.684 0 0 0-.243-.05.841.841 0 0 0 0 1.674.21.21 0 0 1 0 .417 1.11 1.11 0 0 1-.976-.641.882.882 0 0 0-.726.912z",
    transform: "translate(-.21 -3.861)",
    style: {
      stroke: "#a7a7a7",
      strokeWidth: ".3px",
      fill: "#a7a7a7"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSublineAi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sublineAi.aa68f9a3.svg";
export { ForwardRef as ReactComponent };